<template>
  <div class="columns is-multiline content" v-if="ligneCommandeTemp">
    <b-field :label="$t('editionRemise.label')"
             class="column is-12">
      <remise-personnalisee
        v-model="remiseAAtteindreAAjouter.libelle"
        :hidePopUp="hidePopUp">
      </remise-personnalisee>
    </b-field>
    <b-field :label="$t('editionRemise.prixDepart')"
             class="column is-3">
      <input-currency
        v-model="ligneCommandeTemp.totalHt"
        disabled
      >
      </input-currency>
    </b-field>
    <b-field :label="$t('editionRemise.prixAAtteindre')"
             class="column is-3">
      <input-currency
        @catchBlur="changeDisplayRemise()"
        checkBlur
        v-model="prixAAtteindre"
      >
      </input-currency>
    </b-field>
    <b-field :label="getLabelDiscoutOrAugmentation"
             class="column is-3">
      <b-input
        disabled
        v-model="remiseDisplayAAtteindreMode"
        custom-class="right"
      ></b-input>
    </b-field>
    <b-field class="column is-3 control bfieldWhitoutLabel">
      <a class="is-addOrEdit button is-fullwidth"
         @click="ajouterRemise(remiseAAtteindreAAjouter, true)">
        {{ $t('editionRemise.add') }}
      </a>
    </b-field>
  </div>
</template>

<script>
import inputCurrency from '@/components/general/inputCurrency';
import genererLigneRemise from '@/services/devisCommandes/genererLigneRemise';
import cloneDeep from 'lodash/cloneDeep';
import calculLignesRemise from '@/services/devisCommandes/calcul/calculLignesRemise';
import findPourcentageRemise from '@/services/devisCommandes/findPourcentageRemise';
import decimalsFormater from '@/services/general/decimalsFormater';
import {
  TYPE_REMISE_FRONT_REMISE_POURCENTAGE,
} from '@/configuration/devisConf';
import messageErreur from '@/services/general/messageErreur';
import remiseValidation from '@/services/devisCommandes/validation/addRemiseValidation';
import * as remiseF2B from '@/services/devisCommandes/traductionRemiseBackFront';
import remisePersonnalisee from '@/components/devisCommandes/remisePersonnalisee';

export default {
  name: 'modeAAtteindre',
  props: {
    ligneCommandeTemp: {
      required: true,
      type: Object,
    },
  },
  components: {
    inputCurrency,
    remisePersonnalisee,
  },
  data() {
    return {
      remiseAAtteindreAAjouter: genererLigneRemise(),
      prixAAtteindre: null,
      remiseDisplayAAtteindreMode: '0 %',
      openPopUpAddEditLibelleRemise: false,
      dataAutoCompleteRemise: [],
      hidePopUp: false,
    };
  },
  methods: {
    changeDisplayRemise() {
      findPourcentageRemise(this.remiseAAtteindreAAjouter, this.prixAAtteindre,
        this.ligneCommandeTemp.totalHt);
      const remise = decimalsFormater(this.remiseAAtteindreAAjouter.remise);
      if (this.remiseAAtteindreAAjouter.typeRemise === TYPE_REMISE_FRONT_REMISE_POURCENTAGE) {
        this.remiseDisplayAAtteindreMode = (remise * -1) + ' %';
      } else this.remiseDisplayAAtteindreMode = remise + ' %';
    },
    ajouterRemise(remiseAAjouter, modeAAtteindre) {
      this.messages = [];
      remiseAAjouter.montant = 0;
      if (this.prixAAtteindre === null && modeAAtteindre) {
        messageErreur(this.$i18n, this.$i18n.t('editionRemise.errors.prixAAtteindreNull'));
        return;
      }
      if (modeAAtteindre && remiseAAjouter.remise === 0) {
        messageErreur(this.$i18n, this.$i18n.t('editionRemise.remisePrixDepartZero'));
        this.prixAAtteindre = null;
        return;
      }
      remiseValidation(remiseAAjouter, this.messages);
      if (this.messages.length > 0) return;
      this.currentOrdre = this.findOrdre;
      remiseAAjouter.ordre = this.currentOrdre;
      remiseAAjouter.isModeAAtteindre = modeAAtteindre;
      const realRemise = cloneDeep(remiseAAjouter);
      remiseF2B.fromTypeRemiseFront(realRemise, remiseAAjouter.typeRemise);
      remiseF2B.fromMontantRemiseFront(realRemise, remiseAAjouter.typeRemise,
        remiseAAjouter.remise);
      this.ligneCommandeTemp.lignesRemise.push(realRemise);
      calculLignesRemise(this.ligneCommandeTemp);
      this.remiseAAjouter = genererLigneRemise();
      this.prixAAtteindre = null;
      this.remiseDisplayAAtteindreMode = '0 %';
      if (this.ligneCommandeTemp.listeMontant) { // utile pour la soulte sur multi remise
        this.ligneCommandeTemp.listeMontant.push(this.ligneCommandeTemp.totalHt);
      }
    },
  },
  computed: {
    getLabelDiscoutOrAugmentation() {
      if (this.remiseAAtteindreAAjouter.typeRemise === TYPE_REMISE_FRONT_REMISE_POURCENTAGE) {
        return this.$i18n.t('editionRemise.discount');
      }
      return this.$i18n.t('editionRemise.majoration');
    },
    findOrdre() {
      if (this.ligneCommandeTemp.lignesRemise.length === 0) {
        return 0;
      }
      const ordres = this.ligneCommandeTemp.lignesRemise.map((r) => {
        return r.ordre;
      });
      return Math.max(...ordres) + 1;
    },
  },
};
</script>

<style scoped>

</style>
